import { all, call, put, takeEvery, fork } from 'redux-saga/effects';
import {
    dispatchAdminDataUpdateSuccess,
    dispatchAdminDataUpdateFailure,
} from './actions';
import {
    DISPATCH_ADMIN_DATA_UPDATE,
} from './constants';
const API_ENDPOINT_URL = process.env.REACT_APP_AZURE_KDMAPIPHP_TRIGGERWEBJOBS_RUN;
const API_ENDPOINT_AUTH = process.env.REACT_APP_AZURE_KDMAPIPHP_TRIGGERWEBJOBS_RUN_AUTH;

function* dispatchAdminDataUpdateSaga() {
    const options = {
        method: 'POST',
        headers: {
            "Accept": "*/*",
            'Authorization': `Basic ${API_ENDPOINT_AUTH}`,
        }
    }
    try {
        const response = yield call(fetch, API_ENDPOINT_URL, options);
        if (response.status === 200) {
            const dispatchAdminDataUpdateEstimatedEndTime = Date.now() + 10 * 60 * 1000; // 10 minutes from now in ms
            yield put(dispatchAdminDataUpdateSuccess(response.status, dispatchAdminDataUpdateEstimatedEndTime));
        } else if (response.status === 500) {
            const message = 'Data is being updated from source, please wait';
            const dispatchAdminDataUpdateEstimatedEndTime = Date.now() + 10 * 60 * 1000;
            yield put(dispatchAdminDataUpdateFailure(message, dispatchAdminDataUpdateEstimatedEndTime));
        } else if (response.status === 401) {
            const message = 'Invalid credentials UNAUTHENTICATED';
            yield put(dispatchAdminDataUpdateFailure(message));
        } else {
            const message = 'An error occurred';
            yield put(dispatchAdminDataUpdateFailure(message));
        }
    } catch (error) {
        let message = error.description || 'An error occurred';
        yield put(dispatchAdminDataUpdateFailure(message));
    }
};

// Watcher Saga
export function* watchDispatchAdminDataUpdate() {
    yield takeEvery(DISPATCH_ADMIN_DATA_UPDATE, dispatchAdminDataUpdateSaga);
};

export default function* adminUpdatePushButtonSaga() {
    yield all([
        fork(watchDispatchAdminDataUpdate),
    ]);
};